import { Period } from './date-range-filter';

const iso = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/// Últimos 30 dias: responde "como estamos" sem escolha prévia.
export function initialPeriod(): Period {
    const today = new Date();
    const start = new Date();

    start.setDate(today.getDate() - 29);

    return { from: iso(start), to: iso(today) };
}
